/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Participation_Agreement_RemoveInputs */

const en_admin_participation_agreement_remove = /** @type {(inputs: Admin_Participation_Agreement_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove PDF`)
};

const de_admin_participation_agreement_remove = /** @type {(inputs: Admin_Participation_Agreement_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF entfernen`)
};

/**
* | output |
* | --- |
* | "Remove PDF" |
*
* @param {Admin_Participation_Agreement_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_participation_agreement_remove = /** @type {((inputs?: Admin_Participation_Agreement_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Participation_Agreement_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_participation_agreement_remove(inputs)
	return en_admin_participation_agreement_remove(inputs)
});